'use strict';

import angular from 'angular';

export default class MemTypeFormCtrl {
  model = {
    name: '',
    isActive: true
  };
  // Auth; //TODO: add auth check

  constructor($state, $stateParams, LoaderSvc, MemTypeSvc, GroupAuthSvc) {
    var groupId = $stateParams.groupId;
    this.groupId = groupId;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.MemTypeSvc = MemTypeSvc;
    this.LoaderSvc = LoaderSvc;

    var that = this;

    var isCreate = $state.current.name.indexOf('new') !== -1;
    // create
    if(isCreate) {
      // authorization
      GroupAuthSvc.validatePermission(groupId, 'memberType', 'C');

      this.submit = this.createMemType;
      that.headerText = 'New Member Type';
      that.submitText = 'Create Member Type';
      this.cancelSref = 'group.view.settings.memType.list';

    // edit
    } else {
      // authorization
      GroupAuthSvc.validatePermission(groupId, 'memberType', 'U');

      this.submit = this.updateMemType;
      var mtId = $stateParams.mtId;
      that.mtId = mtId;
      that.headerText = 'Edit Member Type';
      that.submitText = 'Update Member Type';
      this.MemTypeSvc.get({groupId, id: mtId}).$promise
        .then(function(gt) { that.model = angular.copy(gt); });
      this.cancelSref = 'group.view.settings.memType.view({mtId: '
        + mtId + ' })';
    }
  }

  createMemType() {
    var that = this;
    that.LoaderSvc.start();
    that.model.definedByGroupId = Number(that.groupId);
    that.MemTypeSvc.create({groupId: that.groupId}, this.model).$promise
      .then(function(mt) {
        that.LoaderSvc.stopSuccess('Member Type Created');
        that.$state.go('group.view.settings.memType.view', {mtId: mt.id});
      }).catch(function(err) {
        that.LoaderSvc.stopError(err);
      });
  }

  updateMemType() {
    var that = this;
    that.LoaderSvc.start();

    this.MemTypeSvc
      .update({groupId: that.groupId, id: that.mtId}, this.model).$promise
      .then(function() {
        that.$state.go('group.view.settings.memType.view', {mtId: that.mtId});
        that.LoaderSvc.stopSuccess('Member Type Updated');
      })
      .catch(function(err) {
        that.LoaderSvc.stopError(err);
      });
  }
}

MemTypeFormCtrl.$inject = [
  '$state',
  '$stateParams',
  'LoaderSvc',
  'MemTypeSvc',
  'GroupAuthSvc'
];
